/* eslint-disable react/prop-types */
import React, { Children } from 'react';

import { Wrapper, FullHeightRow, FullHeightCol } from './styled-components';

const Paper = ({ children }) => (
  <Wrapper>
    <FullHeightRow>
      {Children.map(children, (child, i) => (
        <FullHeightCol key={i} xs={12}>
          {child}
        </FullHeightCol>
      ))}
    </FullHeightRow>
  </Wrapper>
);

export default Paper;



// WEBPACK FOOTER //
// ./src/views/sports-connect/components/Paper/index.js